import React, { useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Globe, CheckCircle, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Şu an sadece İngilizce aktif - diğer diller sonra eklenecek
const SUPPORTED_LANGUAGES = [
  { code: 'english', name: 'English', native_name: 'English', flag: '🇬🇧' }
];

const LanguageSelector = ({ onLanguageSelected, onClose }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSelectLanguage = async () => {
    if (!selectedLanguage) {
      toast.error('Lütfen bir dil seçin');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('session_token');
      await axios.post(
        `${API}/auth/select-language`,
        { language: selectedLanguage },
        { 
          withCredentials: true,
          headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        }
      );
      
      toast.success('Dil seçimi kaydedildi! 🎉');
      onLanguageSelected(selectedLanguage);
    } catch (error) {
      console.error('Language selection error:', error);
      toast.error('Dil seçimi kaydedilemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <Card className="w-full max-w-2xl border-4 border-blue-300 shadow-2xl bg-gradient-to-br from-white to-blue-50">
        <CardHeader className="text-center pb-2">
          <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-xl">
            <Globe className="w-10 h-10 text-white" />
          </div>
          <CardTitle className="text-3xl font-black bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Hangi Dili Öğrenmek İstiyorsun? 🌍
          </CardTitle>
          <CardDescription className="text-lg text-gray-600">
            Öğrenmek istediğin dili seç ve maceraya başla!
          </CardDescription>
        </CardHeader>
        
        <CardContent className="p-6">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
            {SUPPORTED_LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => setSelectedLanguage(lang.code)}
                className={`relative p-6 rounded-2xl border-4 transition-all duration-300 transform hover:scale-105 ${
                  selectedLanguage === lang.code
                    ? 'border-blue-500 bg-gradient-to-br from-blue-100 to-purple-100 shadow-xl'
                    : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-lg'
                }`}
              >
                {selectedLanguage === lang.code && (
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
                    <CheckCircle className="w-5 h-5 text-white" />
                  </div>
                )}
                <div className="text-5xl mb-3">{lang.flag}</div>
                <div className="font-bold text-gray-900">{lang.name}</div>
                <div className="text-sm text-gray-500">{lang.native_name}</div>
              </button>
            ))}
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={handleSelectLanguage}
              disabled={!selectedLanguage || loading}
              className="flex-1 h-14 text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 shadow-lg"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Kaydediliyor...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <Sparkles className="w-5 h-5" />
                  Başla! 🚀
                </span>
              )}
            </Button>
            
            {onClose && (
              <Button
                variant="outline"
                onClick={onClose}
                className="h-14 text-lg font-bold border-2"
              >
                Daha Sonra
              </Button>
            )}
          </div>
          
          <p className="text-center text-sm text-gray-500 mt-4">
            💡 Dil seçimini daha sonra ayarlardan değiştirebilirsin
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LanguageSelector;
